import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useProductsCollection = (params: any) => {
  return useQuery({
    queryKey: ['getProductsCollection', JSON.stringify(params)],
    queryFn: async () => {
      const { data } = await axios.get('/api/items', {
        params,
      });
      return data;
    },
    enabled: false,
  });
};
